import { ErrorMessage, FieldProps } from "formik"
import { FC, useEffect, useState } from "react"
import "./Checkbox.scss"
import { SelectFieldProps, SelectTypes } from "./interfaces"

const Checkbox: FC<FieldProps & SelectFieldProps> = (
  { options = [], field, form, placeholder, required = false, ...props }
) => {
  const [optionsSelected, setOptionsSelected] = useState<string[]>([])

  const getKey = (value: string) => value.replace(/\s+/g, "-").toLowerCase()
  const handleOnClick = (item: SelectTypes) => {
    const { value } = item

    setOptionsSelected(prevValue => {
      const newValue = prevValue.includes(value) ? prevValue.filter(v => v !== item.value) : [...prevValue, item.value]
      return newValue
    })
  }
  useEffect(() => {
    form.setFieldValue(field.name, optionsSelected.join(", "))
  }, [optionsSelected])
  return (
    <>
      <p className='card-list-heading'>
        {placeholder}
        {required && <span className='login-form__label-required'> *</span>}
      </p>
      <ul className='card-list cardlist-v2'>
        {options.map(item => (
          <li
            key={getKey(item.value)}
            className={`small-card small-card-${optionsSelected.includes(item.value) ? "selected" : ""}`}
            onClick={() => handleOnClick(item)}
          >
            <div className='small-card-radio' />
            <div className='small-card-text'>{item.value}</div>
          </li>
        ))}
      </ul>
      <ErrorMessage name={field.name} component='span' className='login-form__error-message' />
    </>
  )
}

export default Checkbox
